import * as Sentry from "@sentry/react";

export default () => {
  console.log("init", import.meta.env.VITE_SENTRY_DSN);
  if (import.meta.env.VITE_SENTRY_DSN) {
    
    Sentry.init({
      dsn: import.meta.env.VITE_SENTRY_DSN,
      release: `CRM.ID@${import.meta.env.PACKAGE_VERSION}`,
      normalizeDepth: 5,
      ignoreErrors: [
        "ResizeObserver loop limit exceeded",
        "Cannot redefine property: googletag",
        "ResizeObserver loop completed with undelivered notifications",
        "Unexpected token _ in JSON at position 0",
        "SecurityError: The operation is insecure.",
        /Loading (?:CSS )?chunk \d+ failed/i,
        /Failed to fetch dynamically imported module/i,
        /error loading dynamically imported module/i,
        /Importing a module script failed/i,
        /Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node./i,
        /Unable to preload CSS/,
        /Cannot read properties of null (reading 'style')/,
      ],
      beforeSend(event, hint) {
        const err = hint?.originalException || hint?.syntheticException;
        const msg = String(err?.message || event?.message || "");

        // Group error chunk mismatch biar gak spam
        if (isChunkLoadError(err)) {
          event.fingerprint = ["chunk-mismatch"];
        }

        // Drop sebagian error saat offline
        if (!navigator.onLine && msg.includes("Failed to fetch")) {
          return null;
        }

        // tag tambahan berguna
        event.tags = {
          ...(event.tags || {}),
          app_version: import.meta.env.VITE_VERSION,
        };

        return event;
      },
    });
  }
};

export const reportToSentry = ({
  message,
  context = { name: "", context: {} },
  level = "warning",
  tags = {},
}) => {
  if (!import.meta.env.VITE_SENTRY_DSN) {
    console.warn("[Sentry Report]", message, context);
    return;
  }

  Sentry.withScope((scope) => {
    scope.setLevel(level);
    scope.setContext(context.name, context.context);
    scope.setTags(tags);

    Sentry.captureMessage(message);
  });
};

export function isChunkLoadError(e) {
  const msg = String(e?.message || e?.reason || "");
  return (
    msg.includes("Failed to fetch dynamically imported module") ||
    msg.includes("error loading dynamically imported module") ||
    msg.includes("Importing a module script failed") ||
    msg.includes("Unable to preload CSS") ||
    msg.includes("ChunkLoadError") ||
    msg.includes("Loading chunk") ||
    msg.includes("Expected a JavaScript-or-Wasm module script")
  );
}
